    <h4 mat-dialog-title>Internal Review</h4>
    <div class="row">
        <div class="col-12" *ngIf="isPTL">
            <p>Comments Project Team Leader</p> 
            <div class="bl-textarea ">
                <textarea 
                class="bl-textarea__area--size-small input-text"
                [readonly]="isFinishIcr"
                [(ngModel)]="comentsPTL"
                ></textarea>
            </div>
        </div>
        <div class="col-12" *ngIf="isPRM">
          <p>Comments Procurement Fiduciary Specialist</p> 
          <div class="bl-textarea ">
              <textarea 
              class="bl-textarea__area--size-small input-text"
              [readonly]="isFinishIcr"
              [(ngModel)]="comentsPRM" 
              ></textarea>
          </div>
        </div>
        <div class="col-12" *ngIf="false">
          <p>Comments Summary</p> 
          <div class="bl-textarea ">
              <textarea 
              class="bl-textarea__area--size-small input-text"
              ></textarea>
          </div>
        </div>
    </div>
    
    <div class="row bl-finding-form__btn-location-right">
        <div class="col-12">
            <div>
                <button class="bl-button--btn-cancel bl-finding-form__btn-location-right--spacing-right" (click)="onCancelClick()">
                  Cancel
                </button>
                <button class="bl-button--btn-save" (click)="onSaveClick()" [disabled]="isFinishIcr">
                  Save
                </button>
              </div>
        </div>
    </div>
    
    